<template lang="pug">

  section.intro
    p El número de mujeres que practica algún deporte sigue creciendo.
    p Muchas son las que optan por especialidades de alta carga física, superando barreras creadas por estereotipos sociales y demostrando que el deporte hace mucho tiempo dejo de ser cosa de hombres.
    p Revisa cuáles son las disciplinas que ellas prefieren en el siguiente especial:

</template>

<script lang="js">
  export default  {
    name: 'intro',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .intro {
    max-width: 980px;
    margin: 5rem auto;
    @media screen and (max-width: 980px){
      margin: 0 auto;
      padding: 0 1rem;
    }
    p{
      font-size: 1.5rem;
      font-weight: bold;
      text-align: center;
    }
  }
</style>
